export const getLabData = (store) => store.labform.editData;
